<template>
  <div class="printout-container">
    <form v-if="!hideCall" class="frm-contact frm-request-printout" @submit.prevent="submitForm">
      <div>
        <input type="hidden" name="page" value="Request Printout" />
        <div class="row" v-for="(field, index) in formFields" :key="index">
          <label :for="field.id" :class="labelClasses">{{ field.label }}</label>
          <div class="col-sm-8">
            <template v-if="field.type == 'text'">
              <input
                v-if="field.required"
                :id="field.id"
                type="text"
                :name="field.name"
                :class="fieldClasses"
                :placeholder="field.placeholder"
                required
              />
              <input
                v-else
                :id="field.id"
                type="text"
                :name="field.name"
                :class="fieldClasses"
                :placeholder="field.placeholder"
              />
            </template>
            <template v-else-if="field.type == 'email'">
              <input
                v-if="field.required"
                :id="field.id"
                type="email"
                :name="field.name"
                :class="fieldClasses"
                autocomplete="email"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                :placeholder="field.placeholder"
                required
              />
              <input
                v-else
                :id="field.id"
                type="email"
                :name="field.name"
                :class="fieldClasses"
                autocomplete="email"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                :placeholder="field.placeholder"
              />
            </template>
            <template v-else-if="field.type == 'tel'">
              <input
                v-if="field.required"
                :id="field.id"
                type="tel"
                :name="field.name"
                :class="fieldClasses"
                autocomplete="tel"
                pattern="^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$"
                :placeholder="field.placeholder"
                required
              />
              <input
                v-else
                :id="field.id"
                type="tel"
                :name="field.name"
                :class="fieldClasses"
                autocomplete="tel"
                pattern="^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$"
                :placeholder="field.placeholder"
              />
            </template>
            <template v-else-if="field.type == 'select'">
              <select
                v-if="field.required"
                :id="field.id"
                :name="field.name"
                :class="fieldClasses"
                @change="
                  field.changeFunction
                    ? field.changeFunction($event)
                    : doNothing()
                "
                required
              >
                <option v-if="field.placeholder" value="">
                  {{ field.placeholder }}
                </option>
                <template v-if="field.name === 'country'">
                  <option
                    v-for="(option, optionIndex) in countries()"
                    :key="`${option.value}-${field.name}-${optionIndex}`"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                </template>
                <template v-if="field.name === 'state'">
                  <option
                    v-for="(option, optionIndex) in activeStates"
                    :key="`${option}-${field.name}-${optionIndex}`"
                    :value="option"
                  >
                    {{ option }}
                  </option>
                </template>
              </select>
            </template>
            <template v-else>
              {{ field }}
            </template>
          </div>
        </div>

        <div class="row hide">
          <input
            type="hidden"
            id="ct_title"
            name="title"
            :value="
              decodeURIComponent(selectedProduct.title)
                .replaceAll(/\+/g, ' ')
                .replaceAll(/\\/g, '')
            "
          />
          <template v-if="firstFrame">
            <input type="hidden" id="ct_sku1" name="sku1" :value="firstFrame" />
            <input type="hidden" id="ct_sku1_pdf" name="sku1_pdf" value="" />
          </template>

          <template v-if="secondFrame">
            <input
              type="hidden"
              id="ct_sku2"
              name="sku2"
              :value="secondFrame"
            />
            <input type="hidden" id="ct_sku2_pdf" name="sku2_pdf" value="" />
          </template>

          <input
            type="hidden"
            id="ct_dimension"
            name="dimension"
            :value="productDimensions"
          />
          <template v-if="thirdFrame">
            <input type="hidden" id="ct_sku3" name="sku3" :value="thirdFrame" />
            <input type="hidden" id="ct_sku3_pdf" name="sku3_pdf" value="" />
          </template>
        </div>
      </div>

      <div class="text-center">
        <button
          type="submit"
          class="submit-button"
          :class="{ 'btn--loading': isSubmitting }"
          :disabled="isSubmitting"
        >
          Request Printout
        </button>
        <div v-if="errorMessage" class="error-message_container">
          <span class="error-message_message">{{ errorMessage }}</span>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "PrintoutRequest",
  props: {
    selectedProduct: Object,
    productType: String,
    hideCall: Boolean
  },
  data() {
    return {
      fieldClasses: "form-control",
      labelClasses: "col-sm-4 col-form-label text-left",
      activeCountry: "US",
      errorMessage: "",
      isSubmitting: false,
      formFields: this.getFormFields(),
      firstFrame: this.getFramePart(0),
      secondFrame: this.getFramePart(1),
      thirdFrame: this.getFramePart(2),
      googleScriptEndpoint:
        "https://script.google.com/macros/s/AKfycbyrEVZ_zIMhGSDmrdvnD0My-gsGcGqaTGXAjTo37YWNRGQHr_vv/exec",
    };
  },
  watch: {
    selectedProduct() {
      this.firstFrame = this.getFramePart(0);
      this.secondFrame = this.getFramePart(1);
      this.thirdFrame = this.getFramePart(2);
    },
  },
  computed: {
    activeStates() {
      if (this.activeCountry === "US") {
        return [
          "Alabama",
          "Alaska",
          "American Samoa",
          "Arizona",
          "Arkansas",
          "Armed Forces Africa",
          "Armed Forces Americas",
          "Armed Forces Canada",
          "Armed Forces Europe",
          "Armed Forces Middle East",
          "Armed Forces Pacific",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "District of Columbia",
          "Federated States Of Micronesia",
          "Florida",
          "Georgia",
          "Guam",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Marshall Islands",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Northern Mariana Islands",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Palau",
          "Pennsylvania",
          "Puerto Rico",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "Utah",
          "Vermont",
          "Virgin Islands",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
        ];
      }
      return [
        "Alberta",
        "British Columbia",
        "Manitoba",
        "Newfoundland and Labrador",
        "New Brunswick",
        "Nova Scotia",
        "Northwest Territories",
        "Nunavut",
        "Ontario",
        "Prince Edward Island",
        "Quebec",
        "Saskatchewan",
        "Yukon Territory",
      ];
    },
    productDimensions() {
      const productTypeSizeMapping = {
        Chair: ["width_1", "depth_size"],
        Chaise: ["chaise_width", "chaise_length"],
        Sectional: ["width_1", "width_2"],
        Desk: ["width_1", "depth_size"],
        Ottoman: ["width_1", "depth_size"],
        Loveseat: ["width_1"],
        "Modular Piece": ["width_1", "depth_size"],
        "Modular Sectional": ["width_1", "width_2", "width_3"],
        "Sectional with Bumper": ["width_1", "width_2"],
        Sofa: ["width_1"],
        "Sofa Bed": ["width_1"],
        "Sofa with Bumper": ["width_1"],
        "Sofa with Chaise": ["width_1", "chaise_width", "chaise_length"],
        "U-Shaped Sectional With Bumpers": ["width_2", "width_1"],
        "U-Shaped Sectional": ["width_2", "width_1"],
        "Double Chaise Sectional": ["width_2", "chaise_width", "chaise_length"],
        "U-Shaped Sectional With Chaise": ["width_1", "width_2", "width_3"],
        "Sectional With Chaise": ["width_1", "width_2", "width_3"],
      };
      const dimensionParts = [];
      if (productTypeSizeMapping[this.productType]) {
        const fieldValues = [];
        for (const field of productTypeSizeMapping[this.productType]) {
          if (this.selectedProduct[field]) {
            fieldValues.push(`${this.selectedProduct[field]}"`);
          }
        }
        if (fieldValues.length === 1) {
          dimensionParts.push(fieldValues[0]);
        } else {
          dimensionParts.push(fieldValues.join(" x "));
        }
      }
      if (this.selectedProduct["depth"]) {
        dimensionParts.push(
          this.selectedProduct["depth"] +
            `${this.selectedProduct["depth_size"]}"`
        );
      }
      if (this.selectedProduct["orientation"]) {
        dimensionParts.push(
          "Orientation:" + this.selectedProduct["orientation"]
        );
      }
      return dimensionParts.join(",");
    },
  },
  methods: {
    getFramePart(frameToGet) {
      const frames = this.selectedProduct.frame_codes.split("|");
      if (frames[frameToGet]) return frames[frameToGet];
      return "";
    },
    doNothing() {},
    submitForm() {
      if (!this.isSubmitting) {
        this.isSubmitting = true;
        this.errorMessage = "";
        const serializedForm = new FormData(this.$el.querySelector("form"));
        const axiosOptions = {
          method: "POST",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: new URLSearchParams(serializedForm).toString(),
          url: this.googleScriptEndpoint,
        };
        axios(axiosOptions)
          .then((response) => {
            console.log(response);
            location.href =
              location.pathname + "?view=printout&contact_posted=true";
          })
          .catch((err) => {
            console.log(err);
            this.errorMessage =
              "An Unexpected Error Has Occured. Please Try Again Later.";
            this.isSubmitting = false;
          });
      }
    },
    countries() {
      return [
        {
          value: "US",
          label: "United States",
        },
        {
          value: "CA",
          label: "Canada",
        },
      ];
    },
    setCountry(event) {
      this.activeCountry = event.target.value;
    },
    getFormFields() {
      return [
        {
          id: "ct_first_name",
          name: "first_name",
          type: "text",
          placeholder: "",
          label: "*First Name",
          required: true,
        },
        {
          id: "ct_last_name",
          name: "last_name",
          type: "text",
          placeholder: "",
          label: "*Last Name",
          required: true,
        },
        {
          id: "ct_email",
          name: "email",
          type: "email",
          placeholder: "",
          label: "*Email",
          required: true,
        },
        {
          id: "ct_address1",
          name: "address1",
          type: "text",
          placeholder: "",
          label: "Street Address*",
          required: true,
        },
        {
          id: "ct_address2",
          name: "address2",
          type: "text",
          placeholder: "",
          label: "Street Address 2",
          required: false,
        },
        {
          id: "ct_city",
          name: "city",
          type: "text",
          placeholder: "",
          label: "City*",
          required: true,
        },
        {
          id: "ct_state",
          name: "state",
          type: "select",
          placeholder: "Please select a region",
          label: "State*",
          required: true,
        },
        {
          id: "ct_zip",
          name: "zip",
          type: "text",
          placeholder: "",
          label: "Zip/Postal Code*",
          required: true,
        },
        {
          id: "ct_phone",
          name: "phone",
          type: "tel",
          placeholder: "",
          label: "Telephone*",
          required: true,
        },
        {
          id: "ct_country",
          name: "country",
          type: "select",
          placeholder: "",
          label: "Country*",
          required: true,
          changeFunction: this.setCountry,
        },
      ];
    },
  },
};
</script>
<style scoped>
.printout-container {
  padding: 1rem;
  border-top: 1px solid #cbcbc3;
}
.row {
  display: grid;
  grid-template-columns: 33% 65%;
  gap: 5px;
}
.col-form-label {
  font-weight: 400;
  font-style: normal;
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  text-align: left;
}
.form-control {
  width: 100%;
  box-sizing: border-box;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border: 1px solid #e5e3df;
  display: block;
  margin: 0 0 1em;
  background-color: transparent;
  outline: 0;
  padding: 0.375rem 0.75rem;
}
.submit-button {
  min-width: 206px;
  padding: 7px 10px;
  color: #3a3830;
  border-color: #3a3830;
  text-transform: uppercase;
  font-family: var(--oddit-main-font);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1.5px;
  border-radius: 6px;
  background: 0 0;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-position: right center;
  background-image: url("//cdn.shopify.com/s/files/1/0250/3304/8148/t/121/assets/ico-select.svg?v=14119474279334961291");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-color: transparent;
  padding-right: 28px;
  text-indent: 0.01px;
  cursor: pointer;
}
.form-control:focus {
  color: #495057;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  border: 1px solid #cecac3;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
}
.btn--loading {
  position: relative;

  background-color: #3a3830;
  color: #3a3830;
}
.btn--loading:hover,
.btn--loading:active {
  background-color: #3a3830;
  color: #3a3830;
}
.error-message_container {
  padding: 1rem 1rem 0 1rem;
  display: flex;
  justify-content: center;
}
.error-message_message {
  max-width: 30ch;
  font-weight: 600;
  color: #b91c1c;
}
.btn--loading:after {
  content: "";
  display: block;
  width: 24px;
  height: 24px;
  position: absolute;
  left: 50%;
  top: 44%;
  margin-left: -12px;
  margin-top: -12px;
  border-radius: 50%;
  border: 3px solid #ffffff;
  border-top-color: transparent;
  -webkit-animation: spin 1.5s infinite linear;
  animation: spin 1s infinite linear;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
